export * from "/codebuild/output/src2532066126/src/git-codecommit.eu-west-2.amazonaws.com/v1/repos/vl-app/vl-common/wrapped-antd/index.ts"